import { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import { Tooltip } from 'react-tooltip';
import { useDrag } from 'react-dnd';
import { isMobile, isTablet } from 'react-device-detect';
import { toast } from 'react-toastify';
import { isResponseOk } from '../../../../../../utility/isResponseOk';
import { moveAssignmentToAnotherCellService } from '../../../../../../services/scheduling';
import OvertimeMark from './OvertimeMark';

const BothHalvesCell = ({
  isPrint,
  cell,
  getPeriodData,
  periodData,
  editSidebarAction,
  editSidebarFormData,
  editSidebarSelectedItems,
  setEditSidebarSelectedItems,
  cellAssignmentData,
  setCellAssignmentData,
  editSidebarSelectedUser,
  hasWritePermission,
  showRecurringShifts,
  unit,
  role,
  shiftsData,
  isPastPeriod,
  isSelectingPostShiftsActive,
}) => {
  const textRef = useRef(null);

  const [isBothHalvesTextOverflow, setIsBothHalvesTextOverflow] = useState(false);

  useEffect(() => {
    if (textRef.current && cell.both_halves_user?.user_name) {
      const isOverflowing = textRef.current.scrollWidth > textRef.current.clientWidth;
      setIsBothHalvesTextOverflow(isOverflowing);
    }
  }, [cell.both_halves_user?.user_name]);

  const [collected, drag] = useDrag(
    () => ({
      type: 'scheduling_full_halves_assignment',
      item: { assignment: { ...cell.both_halves_user } },
      canDrag: !isMobile && !isTablet && hasWritePermission && !isPrint && !isSelectingPostShiftsActive && !editSidebarAction,
      end: async (item, monitor) => {
        try {
          const dropResult = monitor.getDropResult();
          if (dropResult?.cell) {
            if (!item.assignment.user) {
              toast.error("Custom users can't be moved between cells", { hideProgressBar: false });
              return;
            }

            const payload = {
              assignment_id: item.assignment.id,
              new_cell_id: dropResult.cell.id,
              half_part: 'both_halves',
            };
            const response = await moveAssignmentToAnotherCellService(payload);
            if (isResponseOk(response)) {
              getPeriodData(true, false, true);
            }
          }
        } catch (e) {
          console.log(e);
        }
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [cell.both_halves_user],
  );

  return (
    <>
      {!isPrint && (isBothHalvesTextOverflow || cell.both_halves_user?.notes) && (
        <Tooltip
          opacity={1}
          id={`user-tooltip-${cell.both_halves_user.id}`}
          place="top"
          content={
            <>
              <span className="cell-assignment-user-name no-hide">{cell.both_halves_user.user_name}</span>
              <span className="cell-assignment-user-note no-hide">
                {cell.both_halves_user?.notes || cell.both_halves_user?.off_reason || ''}
              </span>
            </>
          }
        />
      )}
      <div
        ref={drag}
        className={cx('cell-assignment-item full', {
          isPrint,
          isActive: cellAssignmentData?.cell?.id === cell.id,
          isSelected: editSidebarSelectedUser && editSidebarSelectedUser?.id === cell.both_halves_user.user?.id,
          isSelectedToOffDue: editSidebarSelectedItems?.find((item) => item.cell.id === cell.id && item.halfPart === 'both_halves'),
          isSelectedToRemove: editSidebarSelectedItems?.find((item) => item.cell.id === cell.id && item.halfPart === 'both_halves'),
        })}
        style={{
          backgroundColor: cell.both_halves_user.cell_color,
          color: cell.both_halves_user.font_color,
        }}
        data-tooltip-id={`user-tooltip-${cell.both_halves_user.id}`}
        onClick={() =>
          isPrint ||
          isMobile ||
          !hasWritePermission ||
          showRecurringShifts ||
          isSelectingPostShiftsActive ||
          isSelectingPostShiftsActive ||
          editSidebarAction
            ? undefined
            : setCellAssignmentData({
                unit,
                cell,
                roleName: name,
                roleId: role.id,
                isPermanentRole: !!role.permanent_role,
                shiftLabel: shiftsData[cell.shift_order],
                available: 'both_halves',
                halfPart: 'both_halves',
                assignment: cell.both_halves_user,
                isPosted: false,
                isPastPeriod,
                roleType: role.role,
                isPrint: isPrint,
              })
        }
      >
        <div
          style={cell.is_second_half_posted ? {} : { position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        >
          <span className={cx('cell-assignment-user-name', { 'no-hide': isPrint })}>{cell.both_halves_user.user_name}</span>
          <span
            className={cx('cell-assignment-user-note', { 'no-hide': isPrint })}
            style={cell.both_halves_user?.off_reason ? { color: '#fff' } : {}}
          >
            {cell.both_halves_user?.notes || cell.both_halves_user?.off_reason || ''}
          </span>
        </div>
        <OvertimeMark assignment={cell.both_halves_user} isPrint={isPrint} />
      </div>
    </>
  );
};

export default BothHalvesCell;
